import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
	name: 'day'
})
export class DayPipe implements PipeTransform {
	transform(dateString: any, arg?: any) {
		const date = moment(dateString);
		return date.format('dddd');
	}
}
